import React from 'react';
import { CheckCircle } from 'lucide-react';

export default function ActionedBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-status-success text-white">
      <CheckCircle size={14} />
      Actioned
    </span>
  );
}
